import script from "./HeaderSection.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderSection.vue?vue&type=script&setup=true&lang=js"

import "./HeaderSection.vue?vue&type=style&index=0&id=58e699cc&lang=scss"

const __exports__ = script;

export default __exports__